import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth.service';
import { PatientsService } from '../../patients/patients.service';
import { BaseService } from '../../shared/base.service';
import { HomeService } from '../home.service';
import { AppService } from '../../app.service';
import { HomeComponent } from '../home.component';
import {TabsetComponent} from "ngx-bootstrap/tabs";
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from '../../users/users.service';

@Component({
    selector: 'patient-dashboard-component',
    templateUrl: './patient-dashboard.component.html',
    styleUrls: [],
    providers: [PatientsService, BaseService, HomeService, UsersService]
})

export class PatientDashboardComponent extends HomeComponent implements OnInit, AfterViewInit {
    @ViewChild('tabs', { static: false }) tabs: TabsetComponent;
    patients: Object[];
    patientType = 1;

    constructor(public authService: AuthService,
                public router: Router,
                public translate: TranslateService,
                public baseService: BaseService,
                public appService: AppService,
                public userService: UsersService,
                public patientsService: PatientsService) {
        super(authService, router, translate, baseService, appService, userService);
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        this.appService.fetchUnreadNotification();
    }
}
